import React from "react";

// JSON data for cards
const metrics = [
    {
        id: 1,
        title: "Yet To Start",
        value: "12",
        icon: "ni-alert-circle",
        bg: "#dce7ffff",
        change: "12.5%",
        changeType: "down",
        changeColor: "success",
    },
    {
        id: 2,
        title: "On-going Work Orders",
        value: "23",
        icon: "ni-note-add-c",
        bg: "#ffeecbff",
        change: "15.3%",
        changeType: "up",
        changeColor: "success",
    },
    {
        id: 3,
        title: "In Progress",
        value: "156",
        icon: "ni ni-update",
        bg: "#c8eeffff",
        change: "5.7%",
        changeType: "up",
        changeColor: "primary",
    },
    {
        id: 4,
        title: "Dispatched Orders",
        value: "18",
        icon: "ni-truck",
        bg: "#daffe4ff",
        change: "4.2%",
        changeType: "up",
        changeColor: "success",
    },
];

const WorkOrderPerformanceMetrix = () => {
    return (
        <div className="row mb-1 gy-5 gx-2">
            {metrics.map((metric) => (
                <div className="col-lg-3 col-sm-12 p-1" key={metric.id}>
                    <div
                        className="card shadow-sm border-0"
                        style={{
                            minWidth: "200px",
                            background: metric.bg,
                        }}
                    >
                        <div className="card-body d-flex flex-column">
                            <div className="d-flex justify-content-between align-items-start">
                                {/* Icon */}
                                <i
                                    className={`icon ni ${metric.icon} fs-3 text-dark`}
                                ></i>

                                {/* Badge for % change */}
                                <span
                                    className={`badge bg-light text-${metric.changeColor} align-center`}
                                >
                                    <i
                                        className={`ni ${
                                            metric.changeType === "up"
                                                ? "ni-arrow-up-right"
                                                : "ni-arrow-down-right"
                                        } me-1`}
                                        style={{ fontSize: "1em" }}
                                    ></i>
                                    {metric.change}
                                </span>
                            </div>

                            {/* Title */}
                            <p className="text-muted mb-1 mt-3">
                                {metric.title}
                            </p>

                            {/* Value */}
                            <h4 className="fw-bold mb-0">{metric.value}</h4>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default WorkOrderPerformanceMetrix;
